(function () {
  var RECENT_STORAGE_KEY = 'a4y-recently-viewed-products';
  var CATALOG_STORAGE_KEY = 'a4y-catalog-products-v1';
  var CATALOG_TTL = 30 * 60 * 1000;
  var ROOT_SELECTOR =
    '[data-a4y-recently-viewed-root], [data-a4y-complete-set-root], [data-a4y-cart-upsell-root]';
  var INITIALIZED_ATTR = 'data-a4y-initialized';
  var LOADING_ATTR = 'data-a4y-loading';
  var OBSERVED_ATTR = 'data-a4y-observed';
  var COLOR_WORDS = [
    'beige',
    'black',
    'brown',
    'chocolate',
    'graphite',
    'grey',
    'gray',
    'navy',
    'pink',
    'purple',
    'plum',
    'white',
    'blue',
    'royal',
    'lilac',
    'rose'
  ];
  var catalogPromise;
  var rootObserver;

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function normalizeText(value) {
    return String(value || '').trim().toLowerCase();
  }

  function parseJsonScript(root, selector) {
    var node = root.querySelector(selector);
    if (!node) return null;

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function parseJsonScripts(root, selector) {
    if (!root || !root.querySelectorAll) return [];

    return Array.from(root.querySelectorAll(selector))
      .map(function (node) {
        try {
          return JSON.parse(node.textContent);
        } catch (error) {
          return null;
        }
      })
      .filter(Boolean);
  }

  function formatMoney(amount, currency) {
    var value = Number(amount || 0) / 100;

    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: currency || 'GBP'
      }).format(value);
    } catch (error) {
      return 'GBP ' + value.toFixed(2);
    }
  }

  function normalizeMoneyValue(value) {
    if (value == null || value === '') return 0;

    if (typeof value === 'number') {
      return value > 999 ? value : Math.round(value * 100);
    }

    var numeric = Number(value);
    if (!Number.isFinite(numeric)) return 0;

    return String(value).indexOf('.') !== -1 ? Math.round(numeric * 100) : numeric;
  }

  function getVariantPriceRange(variants) {
    var list = Array.isArray(variants) ? variants : [];
    var prices = list
      .map(function (variant) {
        return normalizeMoneyValue(variant && variant.price);
      })
      .filter(function (value) {
        return value > 0;
      });
    var comparePrices = list
      .map(function (variant) {
        return normalizeMoneyValue(variant && variant.compare_at_price);
      })
      .filter(function (value) {
        return value > 0;
      });

    return {
      price: prices.length ? Math.min.apply(Math, prices) : 0,
      compareAtPrice: comparePrices.length ? Math.max.apply(Math, comparePrices) : 0
    };
  }

  function inferCategory(product) {
    var haystack = normalizeText(
      [product.title, product.product_type, product.type, product.vendor]
        .concat(Array.isArray(product.tags) ? product.tags : [])
        .join(' ')
    );

    if (haystack.indexOf('playsuit') !== -1) return 'playsuit';
    if (
      haystack.indexOf(' set') !== -1 ||
      haystack.indexOf('set ') !== -1 ||
      haystack.indexOf('matching set') !== -1
    )
      return 'set';
    if (
      haystack.indexOf('bra') !== -1 ||
      haystack.indexOf('crop') !== -1 ||
      haystack.indexOf('top') !== -1
    )
      return 'top';
    if (haystack.indexOf('shorts') !== -1) return 'shorts';
    if (haystack.indexOf('leggings') !== -1) return 'leggings';
    return 'other';
  }

  function extractColorHints(product) {
    var hints = [];
    var title = normalizeText(product.title);

    COLOR_WORDS.forEach(function (word) {
      if (title.indexOf(word) !== -1) hints.push(word);
    });

    (product.options || []).forEach(function (option) {
      if (normalizeText(option.name) !== 'color') return;
      (option.values || []).forEach(function (value) {
        var normalized = normalizeText(value);
        if (normalized) hints.push(normalized);
      });
    });

    return Array.from(new Set(hints));
  }

  function sharedCount(a, b) {
    if (!a.length || !b.length) return 0;
    var bSet = new Set(b);
    return a.filter(function (item) {
      return bSet.has(item);
    }).length;
  }

  function mapProduct(product) {
    if (!product || typeof product !== 'object') return null;

    var primaryImage = product.featured_image;
    var variantPrices = getVariantPriceRange(product.variants);

    if (!primaryImage && product.images && product.images[0]) {
      primaryImage = typeof product.images[0] === 'string' ? product.images[0] : product.images[0].src;
    }

    return {
      id: product.id,
      handle: product.handle,
      title: product.title,
      url: product.url,
      vendor: product.vendor || '',
      available: product.available !== false,
      image:
        primaryImage ||
        (product.featured_media && product.featured_media.preview_image && product.featured_media.preview_image.src) ||
        '',
      price: normalizeMoneyValue(product.price) || variantPrices.price,
      compare_at_price: normalizeMoneyValue(product.compare_at_price) || variantPrices.compareAtPrice,
      product_type: product.product_type || product.type || '',
      type: product.type || '',
      tags: Array.isArray(product.tags) ? product.tags : [],
      options: Array.isArray(product.options) ? product.options : [],
      category: inferCategory(product),
      colorHints: extractColorHints(product)
    };
  }

  function categoryPairScore(currentCategory, candidateCategory) {
    if (currentCategory === 'leggings') {
      if (candidateCategory === 'top') return 120;
      if (candidateCategory === 'set') return 92;
      if (candidateCategory === 'shorts') return 12;
      if (candidateCategory === 'leggings') return -18;
    }

    if (currentCategory === 'top') {
      if (candidateCategory === 'leggings') return 120;
      if (candidateCategory === 'set') return 96;
      if (candidateCategory === 'top') return -20;
    }

    if (currentCategory === 'set') {
      if (candidateCategory === 'leggings') return 70;
      if (candidateCategory === 'top') return 66;
      if (candidateCategory === 'playsuit') return 18;
      if (candidateCategory === 'set') return -8;
    }

    if (currentCategory === 'playsuit') {
      if (candidateCategory === 'leggings') return 42;
      if (candidateCategory === 'top') return 36;
      if (candidateCategory === 'set') return 22;
    }

    return candidateCategory === currentCategory ? -12 : 10;
  }

  async function fetchCatalogProducts() {
    var cached;

    try {
      cached = JSON.parse(sessionStorage.getItem(CATALOG_STORAGE_KEY) || 'null');
    } catch (error) {
      cached = null;
    }

    if (cached && cached.expiresAt > Date.now() && Array.isArray(cached.products)) {
      return cached.products;
    }

    var response = await fetch('/collections/all/products.json?limit=250');
    if (!response.ok) throw new Error('Catalog request failed');

    var payload = await response.json();
    var products = (payload.products || []).map(mapProduct).filter(Boolean);

    try {
      sessionStorage.setItem(
        CATALOG_STORAGE_KEY,
        JSON.stringify({
          expiresAt: Date.now() + CATALOG_TTL,
          products: products
        })
      );
    } catch (error) {
      // Ignore storage write failures.
    }

    return products;
  }

  function getCatalogProducts() {
    catalogPromise = catalogPromise || fetchCatalogProducts().catch(function (error) {
      catalogPromise = null;
      throw error;
    });

    return catalogPromise;
  }

  function setLoadingState(root, isLoading) {
    if (!root) return;

    if (isLoading) {
      root.setAttribute(LOADING_ATTR, 'true');
      return;
    }

    root.removeAttribute(LOADING_ATTR);
  }

  function buildCardMarkup(product, currency, label) {
    var image = product.image ? escapeHtml(product.image) : '';
    var title = escapeHtml(product.title);
    var url = escapeHtml(product.url || '/products/' + product.handle);
    var price = formatMoney(product.price, currency);
    var compare = product.compare_at_price ? formatMoney(product.compare_at_price, currency) : '';
    var imageUrl = image ? (image.indexOf('?') === -1 ? image + '?width=720' : image + '&width=720') : '';

    return (
      '<a class="a4y-recommendations__card" href="' +
      url +
      '">' +
      '<div class="a4y-recommendations__media">' +
      (image ? '<img src="' + imageUrl + '" alt="' + title + '" loading="lazy">' : '') +
      '</div>' +
      '<div class="a4y-recommendations__content">' +
      (label ? '<span class="a4y-recommendations__label">' + escapeHtml(label) + '</span>' : '') +
      '<h3 class="a4y-recommendations__title">' +
      title +
      '</h3>' +
      '<div class="a4y-recommendations__price">' +
      '<span>' +
      price +
      '</span>' +
      (compare ? '<s class="a4y-recommendations__compare">' + compare + '</s>' : '') +
      '</div>' +
      '</div>' +
      '</a>'
    );
  }

  function scoreCandidate(current, candidate) {
    if (!candidate.available || candidate.handle === current.handle) return Number.NEGATIVE_INFINITY;

    var score = categoryPairScore(current.category, candidate.category);
    score += sharedCount(current.colorHints || [], candidate.colorHints || []) * 38;
    score += sharedCount(current.tags || [], candidate.tags || []) * 14;

    if (normalizeText(current.vendor) && normalizeText(current.vendor) === normalizeText(candidate.vendor)) {
      score += 4;
    }

    if (
      normalizeText(current.product_type) &&
      normalizeText(current.product_type) === normalizeText(candidate.product_type)
    ) {
      score += 6;
    }

    return score;
  }

  function pickBestMatches(currentProduct, candidates, limit, excludedHandles) {
    var excluded = new Set(excludedHandles || []);

    return candidates
      .filter(function (candidate) {
        return !excluded.has(candidate.handle);
      })
      .map(function (candidate) {
        return {
          product: candidate,
          score: scoreCandidate(currentProduct, candidate)
        };
      })
      .filter(function (entry) {
        return entry.score > Number.NEGATIVE_INFINITY;
      })
      .sort(function (a, b) {
        return b.score - a.score;
      })
      .slice(0, limit)
      .map(function (entry) {
        return entry.product;
      });
  }

  function uniqueProducts(products, excludedHandles) {
    var seen = new Set(excludedHandles || []);

    return (Array.isArray(products) ? products : []).filter(function (product) {
      var mapped = mapProduct(product);
      if (!mapped || !mapped.handle || seen.has(mapped.handle)) return false;
      seen.add(mapped.handle);
      return true;
    });
  }

  function readManualProducts(root, excludedHandles, limit) {
    var lists = parseJsonScripts(root, '[data-a4y-manual-products]');

    if (!lists.length) return [];

    var flattened = lists.reduce(function (all, list) {
      if (Array.isArray(list)) {
        return all.concat(list);
      }

      all.push(list);
      return all;
    }, []);

    return uniqueProducts(flattened, excludedHandles).slice(0, limit);
  }

  function saveRecentlyViewed(product) {
    if (!product || !product.handle) return;
    var mappedProduct = mapProduct(product);
    if (!mappedProduct) return;

    var items = [];
    try {
      items = JSON.parse(localStorage.getItem(RECENT_STORAGE_KEY) || '[]');
    } catch (error) {
      items = [];
    }

    items = items.filter(function (item) {
      return item.handle !== product.handle;
    });
    items.unshift(mappedProduct);
    items = items.slice(0, 12);

    try {
      localStorage.setItem(RECENT_STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      // Ignore storage write failures.
    }
  }

  function readRecentlyViewed() {
    try {
      return JSON.parse(localStorage.getItem(RECENT_STORAGE_KEY) || '[]');
    } catch (error) {
      return [];
    }
  }

  function initRecentlyViewed(root) {
    if (!root) return;

    var data = parseJsonScript(root, '[data-a4y-current-product]');
    var grid = root.querySelector('[data-a4y-recommendations-grid]');
    var currency = root.dataset.currency || 'GBP';
    var limit = parseInt(root.dataset.limit || '4', 10);
    var currentProduct = mapProduct(data);

    if (!grid || !currentProduct || !currentProduct.handle) {
      root.hidden = true;
      root.removeAttribute(INITIALIZED_ATTR);
      return;
    }

    saveRecentlyViewed(data);

    var viewed = readRecentlyViewed().filter(function (item) {
      return item.handle !== currentProduct.handle;
    });

    if (!viewed.length) {
      root.hidden = true;
      root.removeAttribute(INITIALIZED_ATTR);
      return;
    }

    grid.innerHTML = viewed
      .slice(0, limit)
      .map(function (item) {
        return buildCardMarkup(item, currency, 'Recently viewed');
      })
      .join('');

    root.hidden = false;
    root.setAttribute(INITIALIZED_ATTR, 'true');
  }

  function renderMatches(root, products, currency, label) {
    var grid = root.querySelector('[data-a4y-recommendations-grid]');
    if (!grid) return;

    if (!products.length) {
      root.hidden = true;
      root.removeAttribute(INITIALIZED_ATTR);
      return;
    }

    grid.innerHTML = products
      .map(function (product) {
        return buildCardMarkup(product, currency, label);
      })
      .join('');

    root.hidden = false;
    root.setAttribute(INITIALIZED_ATTR, 'true');
  }

  async function initCompleteSet(root) {
    if (!root) return;

    var currentData = parseJsonScript(root, '[data-a4y-current-product]');
    var current = mapProduct(currentData);
    if (!current || !current.handle) {
      root.hidden = true;
      root.removeAttribute(INITIALIZED_ATTR);
      return;
    }

    try {
      var limit = parseInt(root.dataset.limit || '4', 10);
      var currency = root.dataset.currency || 'GBP';
      var excludedHandles = [current.handle];
      var matches = readManualProducts(root, excludedHandles, limit);

      if (matches.length < limit) {
        var catalog = await getCatalogProducts();
        var fallbackMatches = pickBestMatches(current, catalog, limit - matches.length, excludedHandles.concat(
          matches.map(function (product) {
            return product.handle;
          })
        ));
        matches = matches.concat(fallbackMatches);
      }

      renderMatches(root, matches, currency, 'Pair it with');
    } catch (error) {
      root.hidden = true;
      root.removeAttribute(INITIALIZED_ATTR);
    }
  }

  async function initCartUpsell(root) {
    if (!root) return;

    var currentData = parseJsonScript(root, '[data-a4y-cart-product]');
    var current = mapProduct(currentData);
    var cartHandles = parseJsonScript(root, '[data-a4y-cart-handles]') || [];
    if (!current || !current.handle) {
      root.hidden = true;
      root.removeAttribute(INITIALIZED_ATTR);
      return;
    }

    try {
      var limit = parseInt(root.dataset.limit || '2', 10);
      var currency = root.dataset.currency || 'GBP';
      var excludedHandles = cartHandles.concat(current.handle);
      var matches = readManualProducts(root, excludedHandles, limit);

      if (matches.length < limit) {
        var catalog = await getCatalogProducts();
        var fallbackMatches = pickBestMatches(current, catalog, limit - matches.length, excludedHandles.concat(
          matches.map(function (product) {
            return product.handle;
          })
        ));
        matches = matches.concat(fallbackMatches);
      }

      renderMatches(root, matches, currency, 'Add one more piece');
    } catch (error) {
      root.hidden = true;
      root.removeAttribute(INITIALIZED_ATTR);
    }
  }

  function rootNeedsCatalog(root) {
    if (!root || !root.matches) return false;

    return root.matches('[data-a4y-complete-set-root], [data-a4y-cart-upsell-root]');
  }

  function isNearViewport(root) {
    if (!root || typeof root.getBoundingClientRect !== 'function') return true;

    var rect = root.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

    if (rect.width === 0 && rect.height === 0) return false;

    return rect.top <= viewportHeight + 320;
  }

  function getRootObserver() {
    if (rootObserver || !('IntersectionObserver' in window)) {
      return rootObserver;
    }

    rootObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          var root = entry.target;
          rootObserver.unobserve(root);
          root.removeAttribute(OBSERVED_ATTR);
          initRoot(root, true);
        });
      },
      {
        rootMargin: '320px 0px'
      }
    );

    return rootObserver;
  }

  function scheduleRoot(root, force) {
    if (!root) return;

    if (!rootNeedsCatalog(root) || isNearViewport(root)) {
      initRoot(root, force);
      return;
    }

    var observer = getRootObserver();

    if (!observer) {
      initRoot(root, force);
      return;
    }

    if (root.getAttribute(OBSERVED_ATTR) === 'true') return;

    root.setAttribute(OBSERVED_ATTR, 'true');
    observer.observe(root);
  }

  function initRoot(root, force) {
    if (!root || (!force && root.getAttribute(INITIALIZED_ATTR) === 'true')) return;
    if (root.getAttribute(LOADING_ATTR) === 'true') return;

    if (root.matches('[data-a4y-recently-viewed-root]')) {
      initRecentlyViewed(root);
      return;
    }

    if (root.matches('[data-a4y-complete-set-root]')) {
      setLoadingState(root, true);
      initCompleteSet(root).finally(function () {
        setLoadingState(root, false);
      });
      return;
    }

    if (root.matches('[data-a4y-cart-upsell-root]')) {
      setLoadingState(root, true);
      initCartUpsell(root).finally(function () {
        setLoadingState(root, false);
      });
    }
  }

  function initRecommendations(container, force) {
    var scope = container || document;

    if (scope.matches && scope.matches(ROOT_SELECTOR)) {
      scheduleRoot(scope, force);
    }

    scope.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      scheduleRoot(root, force);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initRecommendations(document);
    });
  } else {
    initRecommendations(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initRecommendations(event.target, true);
  });

  document.addEventListener('a4y:recommendations:refresh', function (event) {
    var container = event.detail && event.detail.container ? event.detail.container : document;
    initRecommendations(container, true);
  });
})();
